import { render, staticRenderFns } from "./HealthCertificates.vue?vue&type=template&id=c30e34b4&scoped=true"
import script from "./HealthCertificates.vue?vue&type=script&lang=js"
export * from "./HealthCertificates.vue?vue&type=script&lang=js"
import style0 from "./HealthCertificates.vue?vue&type=style&index=0&id=c30e34b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30e34b4",
  null
  
)

export default component.exports